function initTrandingSlider() {
    var trandingSlider = new Swiper('.u-product-upsell-container', {
        spaceBetween: 20,
        slidesPerView: 2,
        autoplay: {
            delay: 300000,
        },
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        }
    });
}

initTrandingSlider();

function newinitcustreviewswiper() {
    var swiper = new Swiper(".u-new-cus-review-slider", {
    slidesPerView: 4,
    spaceBetween: 20,
    autoplay: true,
    autoplay: {
    delay: 3000,
    },
    pagination: {
      el: ".swiper-pagination",
      type: "progressbar",
    },
    breakpoints: {
      348: {
        slidesPerView: 1.1,
         spaceBetween: 10,
      },
      640: {
        slidesPerView: 2,
        spaceBetween: 10,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      }
    }
  });
}
